export default function AIAssistant({ t }) {
  return (
    <section id="ai" className="ai-band">
      <div className="container">
        <div className="reveal ai-grid">
          <div>
            <div className="badge violet">
              <span style={{ fontSize: 13 }}>✦</span>
              <span className="badge-text">{t.eyebrow}</span>
            </div>
            <h2>{t.title}</h2>
            <p className="lead">{t.lead}</p>
            <div className="ai-points">
              {t.points.map((p) => (
                <div className="ai-point" key={p.title}>
                  <div className="t">{p.title}</div>
                  <div className="b">{p.body}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
